import { FALLBACK_LANG, SUPPORTED_LANGS } from './i18n.constants';

/**
 * Returns the first supported language among `candidates` (language tags such as `es-ES`, in order of preference),
 * or the fallback language. A saved user choice can be prepended to take priority over the browser languages.
 */
export function resolveLang(candidates: readonly (string | null | undefined)[]): string {
  for (const tag of candidates) {
    const base = tag?.toLowerCase().split(/[-_]/)[0];
    if (base && SUPPORTED_LANGS.includes(base)) return base;
  }
  return FALLBACK_LANG;
}
